import asyncComponent from '../../components/AsyncComponent';

const AsyncWorkflowEditor = asyncComponent(() => import('../../containers/Workflow/Editor'));

export default AsyncWorkflowEditor;
